/**
 * Polyfill ie11 to stop raven errors
 */
// @ts-ignore
Number.isInteger =
  Number.isInteger ||
  function (value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  };
